export default function pngToJpg(imgUrl) {
  if (/.png/i.test(imgUrl)) {
    imgUrl = `${imgUrl}?format=jpg`;
  }
  return imgUrl;
}